// extracted by mini-css-extract-plugin
export default {"faqSection":"FAQSection_faqSection__Cf6Ch"};